import React from 'react';
import PropTypes from 'prop-types';

import { H2, Text } from 'components/atoms/Typography';
import { Image, Link } from 'components/atoms';
import { Stars } from 'components/review/Stars';
import { PSPReviewCard, SectionHeader } from 'components/molecules';
import { Container } from 'components/atoms/Page';
import ArrowIcon from 'assets/images/icons/psp/arrow.svg';
import Trust from 'assets/images/icons/psp/Star-Trustpilot.svg';
import ReviewHeadingIcon from 'assets/images/icons/size-guide/review-heading-icon.svg';

import './PSPReviewSection.scss';

const Star = () => {
	return (
		<Stars
			rating={4.3}
			outOf={5}
			size="large"
		/>
	);
};

const Header = (props) => {
	switch (props.pageType) {
		case 'PSP':
			return (
				<div className="reviews-section-header">
					<Star />
					<H2
						weight="ultraBold"
						color="white"
					>
						{props.title} {'on '}
					</H2>
					<Image
						className="reviews-trustIcon"
						src={Trust}
						alt="TrustPilot"
					/>
				</div>
			);
		case 'SGP':
			return (
				<SectionHeader
					className="header"
					image={ReviewHeadingIcon}
					title={props.title}
					titleProps={{
						weight: 'ultraBold',
						color: 'white',
						size: 'xlarge',
						family: 'rounded',
					}}
				/>
			);
		default:
			return null;
	}
};

const Footer = (props) => {
	switch (props.pageType) {
		case 'PSP':
			return (
				<div className="trustpilot">
					<Link
						href="https://www.trustpilot.com/review/www.sparefoot.com"
						target="_blank"
						rel="noopener noreferrer"
						color="white"
					>
						<Text
							color="white"
							size="small"
							weight="ultraBold"
						>
							See more reviews on TrustPilot
						</Text>
					</Link>
					<Image
						src={ArrowIcon}
						alt="Arrow Icon"
						className="link-icon"
					/>
				</div>
			);
		case 'SGP':
			return (
				<div className="trustpilot">
					<Star />
					<Link
						href="https://www.trustpilot.com/review/www.sparefoot.com"
						target="_blank"
						rel="noopener noreferrer"
						color="white"
					>
						<Text
							color="white"
							size="small"
							weight="ultraBold"
						>
							SpareFoot has a 4.3 out of 5 star rating from over
							41,000 customer reviews on Trustpilot
						</Text>
					</Link>
				</div>
			);

		default:
			return null;
	}
};

export function PSPReviewSection({ reviews, title, pageType }) {
	return (
		<section
			className={`reviews-section ${pageType.toLowerCase()}`}
			id="reviews-section"
		>
			<Container>
				<Header
					pageType={pageType}
					title={title}
				/>
				<PSPReviewCard
					reviews={reviews}
					pageType={pageType}
				/>
				<Footer pageType={pageType} />
			</Container>
		</section>
	);
}
Header.propTypes = {
	title: PropTypes.string,
	pageType: PropTypes.string,
};

Footer.propTypes = {
	pageType: PropTypes.string,
};
PSPReviewSection.propTypes = {
	title: PropTypes.string,
	reviews: PropTypes.arrayOf(
		PropTypes.shape({
			reviewTitle: PropTypes.string.isRequired,
			reviewRating: PropTypes.number.isRequired,
			reviewText: PropTypes.string.isRequired,
			reviewerInitials: PropTypes.string.isRequired,
			reviewerImage: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.object,
			]).isRequired,
			reviewerName: PropTypes.string.isRequired,
			reviewDate: PropTypes.string.isRequired,
		})
	).isRequired,
	pageType: PropTypes.string,
};

PSPReviewSection.defaultProps = {
	pageType: 'PSP',
};
export default PSPReviewSection;
